import React, {Component} from 'react';

import {
  Row,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  Table,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import PhonePreview from '../../../shared/components/PhonePreview';
import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import Link from 'react-router-dom/NavLink';

import {
  timeForEngagements,
  formatDateRange,
  formatPaymentMethod,
  getPreviewLinkForCampaignWithPreviewId,
  humanReadableList,
  toTitleCase,
  geoFilterSort,
  constraintDisplayName,
  alertApprovers,
  getApprovalLinkForCampaign
} from '../../../shared/utils';

import find from 'lodash/find';
import capitalize from 'lodash/capitalize';

import moment from 'moment';

import { ACTIVE_PROFILE } from '../../../config';

const NATIONWIDE_STATECODE = '__NATION_WIDE__';

class OwnerReviewCampaign extends Component {
  constructor(){
    super();

    this.state = {
      activeEngagementId:'__FEED__',
      validationMessages:{},
      showRejectReason:false,
      hasViewedEngagements:false,
      isLoading:false,
      showQAAnswer:false
    };
  }

  componentDidMount(){
    this.setState({isLoading:true})
    Promise.all([
      this.props.loadCampaignHistory(this.props.campaignId),
      this.props.loadCampaign(this.props.campaignId),
      this.props.loadEngagementsForCampaign(this.props.campaignId),
      this.props.loadPublishersForCampaign(this.props.campaignId),
      this.props.loadCampaignReach(this.props.campaignId),
      this.props.loadRetailers(),
      this.props.loadListOfStatesAndDMAs()
    ])
      .then(() => this.setState({isLoading:false}))
      .catch((err) => this.handleFailure(err))
  }

  handleFailure(err){
    this.setState({isLoading:false})
  }

  handleSubmitClick(){
    const {
      campaign,
      brand,
      agency
    } = this.props;

    const url = getApprovalLinkForCampaign(campaign)

    this.props.approveCampaign(this.props.campaignId)
      .then(() => this.handleAlertApproversIfNeeded())
      .then(() => this.props.showNotification('success','Experience approved and ready for Dabbl review.'));
  }

  handleRejectionSubmit(data){
    const {
      campaignId,
      rejectCampaign,
      showNotification
    } = this.props

    const validationMessages = {};

    const { reason } = data;

    if(!reason || reason.length === 0){
      validationMessages['reason'] = 'Please provide feedback before continuing';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      rejectCampaign(campaignId,reason)
        .then(() => showNotification('success','Feedback sent to team. Experience now in Draft and ready for edits'))
        .catch((err) => this.handleFailure(err));
    }
  }

  handleAlertApproversIfNeeded(){
    const {
      campaign,
      brand,
      agency
    } = this.props;


    if(ACTIVE_PROFILE === 'prod'){
      const url = getApprovalLinkForCampaign(campaign);
      alertApprovers(campaign.name,url,campaign.salesNumber,agency.name,brand.name,campaign.launchDate);
    }
  }


  handleBackClick(){
    const engagementIds = this.props.engagements.map((e) => e.id),
      activeId = this.state.activeEngagementId,
      activeIdIndex = engagementIds.indexOf(activeId),
      activeEngagement = find(this.props.engagements, (e) => e.id === activeId),
      lastId = engagementIds[engagementIds.length - 1],
      previousId = engagementIds[activeIdIndex - 1],
      previousEngagement = find(this.props.engagements, (e) => e.id === previousId),
      showQAAnswer = this.state.showQAAnswer;

    if(activeEngagement && activeEngagement.kind === 'qa' && showQAAnswer){
      this.setState({
        showQAAnswer:false,
        activeEngagementId:activeId
      });

    } else if(previousEngagement && previousEngagement.kind === 'qa' && !showQAAnswer){
      this.setState({
        showQAAnswer:true,
        activeEngagementId:previousId
      });

    } else if(activeId === '__CONCLUSION__'){
      this.setState({
        activeEngagementId:lastId
      });

    } else if(activeIdIndex - 1 >= 0){
      this.setState({
        activeEngagementId:previousId
      });

    } else if(activeIdIndex === 0){
      this.setState({
        activeEngagementId:'__FEED__'
      });

    }
  }

  handleNextClick(){
    const engagementIds = this.props.engagements.map((e) => e.id),
      activeId = this.state.activeEngagementId,
      activeIdIndex = engagementIds.indexOf(activeId),
      activeEngagement = find(this.props.engagements, (e) => e.id === activeId),
      firstId = engagementIds[0],
      nextId = engagementIds[activeIdIndex + 1],
      nextEngagement = find(this.props.engagements, (e) => e.id === nextId),
      showQAAnswer = this.state.showQAAnswer;

    if(activeEngagement && activeEngagement.kind === 'qa' && !showQAAnswer){
      this.setState({
        showQAAnswer:true,
        activeEngagementId:activeId
      });

    } else if(nextEngagement && nextEngagement.kind === 'qa' && showQAAnswer){
      this.setState({
        showQAAnswer:false,
        activeEngagementId:nextId
      });

    } else if(activeId === '__FEED__'){
      this.setState({
        activeEngagementId:firstId
      });

    } else if(activeIdIndex >= 0 && activeIdIndex + 1 < engagementIds.length){
      this.setState({
        activeEngagementId:nextId
      });

    } else if(activeIdIndex + 1 === engagementIds.length){
      this.setState({
        activeEngagementId:'__CONCLUSION__',
        hasViewedEngagements:true
      });
    }
  }

  handleCopyLinkClick(){
    this.linkInput.select();
    document.execCommand('copy');
  }

  getFormattedReach(){
    const {
      possibleStates,
      campaign
    } = this.props;

    const { isLoading } = this.state;

    if(campaign.costPerCompletion === 0){
      return 0;
    }

    const priceReach = Math.floor((campaign.lifetimeBudget || 0) / campaign.costPerCompletion);

    if(isLoading){
      return (<i>Loading</i>)
    } else {
      const audienceReach = campaign.reach,
        reach = Math.min(audienceReach,priceReach);

      return (<span>{(reach || 0).toLocaleString()} consumers</span>);
    }
  }

  getTotalExposureTimeForCampaignWithEngagements(campaign,engagements){
    const seconds = this.getReachForCampaign(campaign) * timeForEngagements(engagements);

    return Math.floor(seconds / (60 * 60))
  }

  getFormattedPaymentMethod(){
    if(this.state.isLoading) return (<i>Loading</i>);

    if(this.props.paymentMethodId){
      if(this.props.paymentMethod.id){
        return formatPaymentMethod(this.props.paymentMethod);
      } else {
        return 'Default Credit Card';
      }
    }

    return 'Account Funds';
  }

  getFormattedPublishers(){
    const {
      campaign,
      retailers
    } = this.props;

    const { isLoading } = this.state;

    if(isLoading){
      return (<i>Loading</i>)
    } else if(!campaign.publisherIds || campaign.publisherIds.length === 0){
      return (<i>None</i>)
    } else if(campaign.publisherIds.length === retailers.length){
      return (<span>Nationwide Dabbl Network</span>)
    } else {
      let selectedPublisherNames = retailers.filter((r) => campaign.publisherIds.indexOf(r.id) >= 0).map((r) => r.name);

      return (<span>{humanReadableList(selectedPublisherNames)}</span>)
    }
  }

  getFormattedAudience(){
    const {campaign,possibleGeoFilters} = this.props;

    const matchingFilterNames = (campaign.filters || [])
      .map((f) => possibleGeoFilters.find((g) => g.code === f.code))
      .filter((f) => !!f)
      .sort((a,b) => geoFilterSort(a,b))
      .map((f) => toTitleCase(f.name.toLowerCase()));


    if(campaign.geoFilterPredicate && possibleGeoFilters.length === 0){
      return (<i>Loading</i>)
    } else if(campaign.geoFilterPredicate === 'include'){
      return humanReadableList(matchingFilterNames);
    } else if(campaign.geoFilterPredicate === 'exclude'){
      return `Nationwide excluding ${matchingFilterNames}`;
    } else if(campaign.geoFilterPredicate === 'zip'){
      return 'Custom';
    } else {
      return 'Nationwide';
    }
  }

  getFormattedResponseTargeting(){
    const {campaign} = this.props;

    const { isLoading } = this.state;

    return constraintDisplayName(campaign);
  }

  getFormattedHistoryAction(action){
    if(action === 'suspended'){
      return 'Paused';
    } else if(action === 'approved'){
      return 'Admin Approved';
    } else if(action === 'adjoyApproved'){
      return 'Dabbl Approved';
    } else if(action === 'submittedAndApproved'){
      return 'Submitted';
    } else if(action === 'adjoyRejected' || action === 'rejected'){
      return 'Changes Needed';
    } else if(action === 'activated'){
      return 'Activated';
    } else if(action === 'duplicated'){
      return 'Created';
    } else if(action === 'fundsRequested'){
      return 'Threshold Reached';
    } else if(action === 'revertedToDraft'){
      return 'Edited';
    } else {
      return capitalize(action);
    }
  }

  render(){
    const {
      brand,
      engagements,
      campaign,
      match,
      agency,
      user,
      history,
      paymentMethod
    } = this.props;

    const {
      activeEngagementId,
      showRejectReason,
      hasViewedEngagements,
      validationMessages,
      showQAAnswer
    } = this.state;

    const responsesURL = match.url.slice(0,match.url.lastIndexOf('/')) + '/responses',
      reviewURL = match.url.slice(0,match.url.lastIndexOf('/')) + '/review',
      approvalNeeded = campaign.status === 'pendingAgency' && user.isOwner;

    const previewUri = `${window.location.protocol}//${window.location.hostname+(window.location.port ? ':'+window.location.port: '')}/preview/${campaign.previewToken}`

    console.log('MY PROPS ARE',this.props);

    return (
      <Container className='UserDataExport OwnerReviewCampaign'>
        <Row>
          <Col xs='8'>
            <br />
            <br />
            <h1>{campaign.name}</h1>
            <h5>
              {brand.name}
              &nbsp;&nbsp;
              <span style={{color:'#a5a5a5',fontSize:'1.1rem'}}>
                {formatDateRange(campaign.launchDate,campaign.endDate)}
              </span>
            </h5>
            <h5>Experience <strong>#{campaign.salesNumber}</strong></h5>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <br />
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={responsesURL}
                  activeClassName='active'
                >
                  Consumer Responses
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={reviewURL}
                  activeClassName='active'
                >
                  Details
                </NavLink>
              </NavItem>
            </Nav>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='8'>
            {approvalNeeded ? (
              <div>
                <p>
                  Review each activity of the experience by clicking the buttons under the phone at the right.  Then either approve or request changes below.
                </p>
                <br />
              </div>
            ) : (
              <br />
            )}
            <Card className='DataCard'>
              <CardBody>
                <strong>Setup Info</strong>
                <br />
                <br />
                <Row>
                  <Col xs='4'>
                    Budget
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      ${(campaign.lifetimeBudget || 0).toLocaleString()}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Cost per Completion
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      ${(campaign.costPerCompletion || 0).toFixed(2)}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='6'>
                    Estimated Experience Duration
                  </Col>
                  <Col xs='6'>
                    <div className='data'>
                      {timeForEngagements(engagements)} seconds
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Estimated Reach
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      {this.getFormattedReach()}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Payment Method
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      {this.getFormattedPaymentMethod()}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Review Link
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      <a href={previewUri} target="_blank">{previewUri}</a>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Publishers
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      {this.getFormattedPublishers()}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Location
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      {this.getFormattedAudience()}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs='4'>
                    Response Targeting
                  </Col>
                  <Col xs='8'>
                    <div className='data'>
                      {this.getFormattedResponseTargeting()}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <br />
            <br />
            <Card className='DataCard'>
              <CardBody>
                <strong>Activity History</strong>
                <br />
                <br />
                {campaign.history ? (
                  <div>
                    {campaign.history.length > 0 ? (
                      <div>
                        {history.map((e) => (
                          <Row key={`${e.action}_${e.timestamp}`}>
                            <Col xs='6'>
                              {this.getFormattedHistoryAction(e.action)}
                            </Col>
                            <Col xs='6'>
                              <div className='data'>
                                {moment(e.timestamp).format('MMM D, YYYY, h:mm:ss a')}
                              </div>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    ) : (
                      <div>None available</div>
                    )}
                  </div>
                ) : (
                  <div>Loading...</div>
                )}
              </CardBody>
            </Card>
            {approvalNeeded && (
              <div className='clearfix'>
                <Button
                  onClick={() => this.handleSubmitClick()}
                  disabled={showRejectReason || !hasViewedEngagements}
                >
                  Approve
                </Button>
                <Button
                  className='pull-right'
                  backgroundColor='transparent'
                  textColor='#666666'
                  borderColor='#cccccc'
                  onClick={() => this.setState({showRejectReason:true})}
                  disabled={showRejectReason || !hasViewedEngagements}
                >
                  Changes Needed
                </Button>
              </div>
            )}
            {approvalNeeded && showRejectReason && (
              <Form onSubmit={(data) => this.handleRejectionSubmit(data)}>
                <br />
                <br />
                <TextInput
                  multiline
                  label='Feedback'
                  name='reason'
                  placeholder='Describe changes required for experience to be approved.'
                  maxLength={1000}
                  warning={validationMessages['reason']}
                />
                <div className='clearfix'>
                  <Button
                    isSubmit
                  >
                    Send Feedback
                  </Button>
                  <Button
                    className='pull-right'
                    backgroundColor='transparent'
                    textColor='#666666'
                    borderColor='#cccccc'
                    onClick={() => this.setState({showRejectReason:false})}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            )}
            <br />
          </Col>
          <Col xs={{size:3,offset:1}}>
            {activeEngagementId && engagements && engagements.length > 0 && (
              <div style={{width:200}}>
                <PhonePreview
                  hideTotalValue
                  phonePlatform='generic'
                  height={400}
                  align='left'
                  activeEngagementId={activeEngagementId}
                  engagements={engagements}
                  feedImageURL={campaign.feedImageURL || require('../../../shared/assets/fpo-tile.png')}
                  feedText={campaign.feedText || ''}
                  valuePerUser={campaign.valuePerUser || 0}
                  conclusionText={campaign.completionText}
                  logoURL={brand.logoURL}
                  conclusionBackgroundColor={brand.primaryColor}
                  completionImageURL={campaign.completionImageURL}
                  brandName={brand.name}
                  showQAAnswer={showQAAnswer}
                  cta={campaign.useCTA ? {link: campaign.ctaLink, color: campaign.ctaColor, text: campaign.ctaText} : null}
                />
                <br />
                <div className='clearfix'>
                  <Button
                    className='pull-left'
                    size='sm'
                    textColor='#666666'
                    borderColor='#cccccc'
                    backgroundColor='#ededed'
                    onClick={() => this.handleBackClick()}
                    disabled={activeEngagementId === '__FEED__'}
                  >
                    Back
                  </Button>
                  <Button
                    className='pull-right'
                    size='sm'
                    textColor='#666666'
                    borderColor='#cccccc'
                    backgroundColor='#ededed'
                    onClick={() => this.handleNextClick()}
                    disabled={activeEngagementId === '__CONCLUSION__'}
                  >
                    Next
                  </Button>
                </div>
                <br />
              </div>
            )}
            <br />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

OwnerReviewCampaign.defaultProps = {
  isOwner:false
};

export default OwnerReviewCampaign;



// WEBPACK FOOTER //
// ./src/routes/OwnerReviewCampaign/components/OwnerReviewCampaign.js